import { createBrowserHistory } from 'history';
import { MCbrowser } from '../../Context/browserContext';

export default  function AuthorizeApi(data) {
    //let ctx = useContext(MCbrowser);
    if ( data.hasOwnProperty("authorize")) {
        if (data.authorize === false || data.authorize === "false"){
            if ( data.hasOwnProperty("refreshToken")) {
                let refreshToken=data.refreshToken;
                if (refreshToken === "") {
                    let history = createBrowserHistory();
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('loggedIn');
                   
                    /*ctx.page=null;
                    ctx.theme="";
                    ctx.isLoggedIn=false;*/

                    history.replace("/auth/login");
                    window.location.reload();
                }else{
                    localStorage.setItem('authToken', refreshToken);
                    return "refreshToken";
                }
            }
        }
        return false;
    }
    return true;
}
